import { t } from '../../../utils'
import styles from './_storeCredit.module.scss'
import { useAuth } from '../../../utils/auth'
import { useEffect, useState } from 'react'
import classnames from 'classnames'

const StoreCredit = () => {
  const { currentUser } = useAuth()
  const [isTooltipVisible, setIsTooltipVisible] = useState(true)

  useEffect(() => {
    const animationTimeoutId = setTimeout(() => {
      setIsTooltipVisible(false)
    }, 10000)

    return () => {
      clearTimeout(animationTimeoutId)
    }
  }, [])

  const handleMouseEnter = () => {
    setIsTooltipVisible(true)
  }
  const handleMouseLeave = () => {
    setIsTooltipVisible(false)
  }

  const amount = currentUser.currentStoreCredit || 0

  return (
    <>
      <a
        href={'/store/cart'}
        className={styles.storeCredit}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <p className={styles.creditAmount}> ${amount}</p>
      </a>
      <div
        className={classnames(
          styles.tooltip,
          isTooltipVisible
            ? styles.animatedBlockSlideRight
            : styles.animatedBlockSlideLeft
        )}
      >
        <p className={styles.creditAmount}>{t('IN STORE CREDITS!')}</p>
      </div>
    </>
  )
}

export default StoreCredit
